import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectComponent } from './select.component';
import { ReactiveFormsModule } from '@angular/forms';

const components = [SelectComponent];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: components
})
export class SelectModule { }
